
var spinLess = {};
import genaration from '../../utils/classname';
var defaultLess = {};
var ringLess = {};
var planeLess = {};
var pulseLess = {};
var waveLess = {};
var chasingDotsLess = {};
var doubleBounceLess = {};
var cubeGridLess = {};
var chasingRingLess = {};
var scaleCircleLess = {};
var threeBounceLess = {};
var fourDotsLess = {};
export var spinClass = genaration(spinLess, 'spin');
export var defaultClass = genaration(defaultLess, 'spin-default');
export var ringClass = genaration(ringLess, 'spin-ring');
export var planeClass = genaration(planeLess, 'spin-plane');
export var pulseClass = genaration(pulseLess, 'spin-pulse');
export var waveClass = genaration(waveLess, 'spin-wave');
export var chasingDotsClass = genaration(chasingDotsLess, 'chasing-dots');
export var doubleBounceClass = genaration(doubleBounceLess, 'double-bounce');
export var cubeGridClass = genaration(cubeGridLess, 'cube-grid');
export var chasingRingClass = genaration(chasingRingLess, 'chasing-ring');
export var scaleCircleClass = genaration(scaleCircleLess, 'scale-circle');
export var threeBounceClass = genaration(threeBounceLess, 'three-bounce');
export var fourDotsClass = genaration(fourDotsLess, 'four-dots');